import { NavLink, Outlet } from 'react-router-dom';
import { cn } from '../../lib/utils';

const TABS = [
    { to: '/admin', label: 'Vue d’ensemble', end: true },
    { to: '/admin/users', label: 'Utilisateurs', end: false },
    { to: '/admin/applications', label: 'Catalogue', end: false },
    { to: '/admin/announcements', label: 'Actualités', end: false },
    { to: '/admin/audit', label: 'Journal', end: false },
];

export function AdminLayout() {
    return (
        <div className="space-y-6">
            <header>
                <h1 className="text-2xl font-bold text-[var(--color-text)]">Administration</h1>
                <p className="mt-1 text-sm text-[var(--color-text-secondary)]">
                    Catalogue et droits d’accès.
                </p>
            </header>

            <nav
                className="flex gap-1 overflow-x-auto border-b border-[var(--color-border)] -mb-px"
                aria-label="Sections d’administration"
            >
                {TABS.map((tab) => (
                    <NavLink
                        key={tab.to}
                        to={tab.to}
                        end={tab.end}
                        className={({ isActive }) =>
                            cn(
                                'px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 transition-colors',
                                isActive
                                    ? 'border-[var(--color-primary)] text-[var(--color-primary)]'
                                    : 'border-transparent text-[var(--color-text-secondary)] hover:text-[var(--color-text)]'
                            )
                        }
                    >
                        {tab.label}
                    </NavLink>
                ))}
            </nav>

            <Outlet />
        </div>
    );
}
